import {Component, Module} from 'app/decorators';


import GroupStore from 'app/stores/group';
import BasePicker from './base.picker';
import tpl from './role.picker.html';


@Module({
    name: "app.directives.group.picker",
    modules: [GroupStore],
})
@Component({
    selector: 'blnd-role',
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        ngChange: '&',
        mode: '@?',
        exclude: '<?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor ($timeout, $element, GroupStore) {
        "ngInject";
        super($element);
        this.$timeout = $timeout;

        this.mode = this.mode || 'view';
        this.exclude = this.exclude || [];

        if (this.mode == 'edit') {
            this.store = GroupStore;
            this.store.init();
            this.store.params.exclude = this.exclude;
            this.store.refresh();
        }
    }

    _ngChange (newV, oldV) {
        this.$timeout(() => this.ngChange(newV, oldV));
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/role.picker.js